import angular from 'angular';

import { accessLevels } from '../constants';

import settingsUrl from './settings.html';
import OrgSettings from './models/OrgSettings';
import visibleHoursPickerComponent from './components/visibleHoursPicker/visibleHoursPickerComponent';
import editShiftTemplateComponent from './components/editShiftTemplate/editShiftTemplateComponent';
import editDayPartComponent from './components/editDayPart/editDayPartComponent';
import dynamicSettingsFieldComponent from './components/dynamicSettingsFieldComponent';
import dayPartsTableComponent from './components/dayPartsTableComponent';
import shiftAlarmsComponent from './components/shiftAlarms/shiftAlarmsComponent';
import shiftAlarmRowComponent from './components/shiftAlarms/shiftAlarmRowComponent';
import ptoResetDateComponent from './components/ptoResetDateComponent';
import GoogleCalendarOauthCtrl from './GoogleCalendarOauthCtrl';
import SettingsWithContext from './components/SettingsWithContext';

const settingsModule = angular.module('settings', []);
settingsModule.config(($stateProvider) => {
  'ngInject';

  $stateProvider.state('settings', {
    url: '/settings?tab&type',
    templateUrl: settingsUrl,
    controllerAs: 'ctrl',
    controllerProvider: async () =>
      (await import(/* webpackChunkName: "settings" */ './EditSettingsCtrl')).default,
    reloadOnSearch: false,
    data: {
      title: 'Settings',
      access: accessLevels.user,
    },
    resolve: {
      personaCollection(PersonaCollection) {
        return PersonaCollection.loadData();
      },
      laborCalendarUISchema(LaborUISchema) {
        return LaborUISchema.getSchema();
      },
      shiftUtils(ShiftUtils) {
        return ShiftUtils.loadAsync();
      },
      integrations(IntegrationService) {
        return IntegrationService.getAvailableIntegrations();
      },
    },
  });

  $stateProvider.state('googleCalendar', {
    url: '/oauth/googleCalendar?code',
    template: `
      <div class="google-calendar-oauth-container">
        <div class="brand-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    `,
    data: {
      title: 'Authenticate',
    },
    controller: GoogleCalendarOauthCtrl,
    controllerAs: 'ctrl',
    resolve: {
      code($transition$) {
        return $transition$.params().code;
      },
    },
  });
});

settingsModule.factory('OrgSettings', OrgSettings);
settingsModule.component('visibleHoursPicker', visibleHoursPickerComponent);
settingsModule.component('editShiftTemplate', editShiftTemplateComponent);
settingsModule.component('editDayPart', editDayPartComponent);
settingsModule.component('dynamicSettingsField', dynamicSettingsFieldComponent);
settingsModule.component('dayPartsTable', dayPartsTableComponent);
settingsModule.component('shiftAlarms', shiftAlarmsComponent);
settingsModule.component('shiftAlarmRow', shiftAlarmRowComponent);
settingsModule.component('ptoResetDate', ptoResetDateComponent);
settingsModule.component('settingsWithContext', SettingsWithContext);

export default settingsModule.name;
